export default __webpack_public_path__ + "static/media/ferocioussmack3.8bc3b6ca.png";